export const PXCardRowTimeline = (function() {
	'use strict';

	let $carousels;

	function init() {
		events();
	}

	function events() {
		$carousels = $('.slick');
		if( !$carousels.length > 0 ) return null;

		$carousels.each(function(){
			let $this = $(this);

			if(!$this.hasClass('slick-initialized')){
				$this.slick({
					arrows: true,
					dots: false,
					infinite: false,
					speed: 300,
					slidesToShow: 3,
					// slidesToScroll: 3,
					swipeToSlide: true,
					responsive: [{ 
						breakpoint: 980,
						settings: {
						  slidesToShow: 2
						}
					},
					{
						breakpoint: 620,
						settings: {
						  slidesToShow: 1
						}
					}]
				});
			}
		});
	}

	return {
		init: init
	};
})();
